// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Cs","title":"i_Ct","item":"i_Cu","without-border":"i_Cv","row":"i_Cw","relative":"i_Cx","link":"i_Cy"};